import { Box, Button, FormControl, IconButton, InputLabel, ListSubheader, MenuItem, Select, SelectChangeEvent, Stack, Typography } from '@mui/material';
import * as React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import EditItemForm from './EditItemForm';
import { Item } from '../Services/Item/ItemApi';
import { useItems } from '../Services/Item/ItemHooks';
import AddIcon from '@mui/icons-material/Add';

interface ItemSelectProps {
    onSelect: (selected: Item) => void;
    selected: Item | undefined;
}

export default function ItemSelect({ onSelect, selected }: ItemSelectProps) {

    const itemQuery = useItems();
    const [openItemModal, setOpenItemModal] = useState(false);
    const [editItem, setEditItem] = useState<Item | undefined>();

    const categoryNames: string[] = itemQuery.data ?
        [...new Set(itemQuery.data.map((i) => i.category!.name))]
        : [];

    const handleSelect = (event: SelectChangeEvent) => {
        const selectedId = event.target.value as string;
        onSelect(itemQuery.data?.find(o => o.id === selectedId)!);
    };
    const openEdit = (item: Item) =>
    {
        setEditItem(item);
        setOpenItemModal(true);
    }
    const onSaved = (item: Item) =>
    {
        setOpenItemModal(false);
        setEditItem(undefined);
        onSelect(item);
    }

    const getMenuItem = (item: Item) => {
        return (
            <MenuItem value={item.id} key={item.id} >
                {item.name}
                <IconButton onClick={() => openEdit(item)} >
                    <EditIcon />
                </IconButton>
            </MenuItem>
        )
    }

    const handleModalClose = () => setOpenItemModal(false);

    return (
        <Box>
            {itemQuery.data ? (
                <Stack direction="row">
                    <FormControl fullWidth>
                    <InputLabel id="item-select-label">Select Item</InputLabel>
                    <Select
                        labelId="item-select-label"
                        label="Select Item"
                        onChange={handleSelect}
                        value={selected?.id ?? ""}
                    >
                        {categoryNames.sort().flatMap(category => [
                            <ListSubheader key={`header-${category}`}>{category}</ListSubheader>,
                            ...itemQuery.data
                                .filter(i => i.category!.name === category)
                                .sort()
                                .map(getMenuItem)
                        ])}
                        </Select>
                    </FormControl>
                    <Button startIcon={<AddIcon />} onClick={() => setOpenItemModal(true)}>Add</Button>
                </Stack>
            ) : (
                <Typography>Loading</Typography>
            )}
            <EditItemForm open={openItemModal} onClose={handleModalClose} onSaved={onSaved} initialItem={editItem} />
        </Box>
    );
}

   


